import SequenceActionWrapper from './SequenceActionWrapper';

export default class SequencedActions {
	constructor() {
		this.isComplete = false;
		this.seqL = [];
		this.complCallBack = null;
		this.breakSeq = false;
	}

	start() {
		this.breakSeq = false;
		this.isComplete = false;
		if (this.breakSeq) return;
		this.add(this.completeAction, this);
		this.seqL[0].invoke();
	}

	add(action, context) {
		var actionW = new SequenceActionWrapper(action, context);
		if (this.seqL.length > 0) {
			this.seqL[this.seqL.length - 1].nextActionWrapper = actionW;
		}
		this.seqL.push(actionW);
	}

	break() {
		this.breakSeq = true;
		this.isComplete = true;
		this.seqL.forEach(sAW => {
			sAW.break = true;
		});
	}

	completeAction(callBack) {
		this.isComplete = true;
	}
}
